import { yupResolver } from '@hookform/resolvers/yup'
import { Box, Flex } from 'components/elements'
import { TextField } from 'components/form'
import { BackNavArrowIcon } from 'components/icons'
import { AnnualRevenueFormData, QuoteProps } from 'features/quote/components/type'
import { QouteLayout } from 'features/quote/page/GetAQuotes'
import { useForm } from 'react-hook-form'
import { Stages, TERMINOLOGY, ValidationErrors } from 'utils/enum'
import { userRegHeadingCss, Form } from 'views/style'
import { FlexWrapCSS, inputStyle, wrapStyle } from 'views/Support/SupportForm'
import * as Yup from 'yup'
import { ChangePolicyFormButtons } from './PolicyCoveragePlan'

const UserAnnualRevenue = (props: QuoteProps) => {
  const { setStage, quoteUserReg, setQuoteUserReg, setOpenModal } = props

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<AnnualRevenueFormData>({
    resolver: yupResolver(Scehema),
    defaultValues: {
      annualRevenue: quoteUserReg?.annualRevenue || undefined,
    },
  })
  const onSubmit = async (data: AnnualRevenueFormData) => {
    const changePlanObject = {
      ...quoteUserReg,
      annualRevenue: data?.annualRevenue,
    }

    setQuoteUserReg?.(changePlanObject)
    setStage?.(Stages.STAGE5)
  }
  return (
    <>
      <Flex align="center">
        <BackNavArrowIcon fontSize={24} style={{ cursor: 'pointer' }} onClick={() => setStage?.(Stages.STAGE3)} />
        <Flex as="h2" justify={'center'} css={userRegHeadingCss}>
          Change {TERMINOLOGY.warranty.singular}
        </Flex>
      </Flex>
      <Flex align="start" css={QouteLayout}>
        <Form onSubmit={handleSubmit(onSubmit)} css={{ width: '100%' }}>
          <Flex css={FlexWrapCSS}>
            <Box css={{ ...wrapStyle, width: '100% !important', paddingLeft: 0 }}>
              <TextField
                type="number"
                label="Annual Revenue($)"
                placeholder="Enter your Annual Revenue($)"
                error={!!errors.annualRevenue}
                helperText={errors.annualRevenue?.message}
                {...register('annualRevenue')}
                css={inputStyle}
                max="9999999"
              />
            </Box>
          </Flex>

          <ChangePolicyFormButtons setOpenModal={setOpenModal} setStage={setStage} setQuoteUserReg={setQuoteUserReg} />
        </Form>
      </Flex>
    </>
  )
}
export const Scehema = Yup.object({
  annualRevenue: Yup.number().typeError(ValidationErrors.ANNUAL_REVENUE_TYPEERROR).positive(ValidationErrors.ANNUAL_REVENUE_POSITIVE).required(ValidationErrors.REQUIRED),
})
export default UserAnnualRevenue
